import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ColoredRadioGroup',

  props: {
    modelValue: {
      type: [String, Number, Boolean, null],
      default: null
    }
  },

  emits: ['update:modelValue'],

  computed: {
    radioColor() {
      // Change color when value is exactly "Yes"
      if (this.modelValue) {
        return 'error'
      }
      return ''     // Default color
    }
  },

  methods: {
    updateValue(newValue) {
      this.$emit('update:modelValue', newValue)
    }
  }
})
